import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { WalletProvider } from "./hooks/useWallet";
import { CurrencyProvider } from "./context/CurrencyContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { OutboxBridge } from "./components/OutboxBridge";
import { SwUpdateBanner } from "./components/SwUpdateBanner";
import AuthPage from "./pages/AuthPage";
import JobsList from "./pages/JobsList";
import NewDispatch from "./pages/NewDispatch";
import JobDetail from "./pages/JobDetail";
import Settings from "./pages/Settings";
import Crew from "./pages/Crew";
import ContractorView from "./pages/ContractorView";
import BillingSuccess from "./pages/BillingSuccess";
import Billing from "./pages/Billing";
import Landing from "./pages/Landing";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import DemoContractorView from "./pages/DemoContractorView";
import { useSandboxHandoff } from "./lib/sandboxDraft";

const SandboxHandoff = () => { useSandboxHandoff(); return null; };

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WalletProvider>
          <CurrencyProvider>
          <SandboxHandoff />
          <OutboxBridge />
          <SwUpdateBanner />
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/v/demo-preview" element={<DemoContractorView />} />
            <Route path="/v/:token" element={<ContractorView />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/app" element={<JobsList />} />
              <Route path="/app/new" element={<NewDispatch />} />
              <Route path="/app/jobs/:id" element={<JobDetail />} />
              <Route path="/app/settings" element={<Settings />} />
              <Route path="/app/crew" element={<Crew />} />
              <Route path="/app/billing" element={<Billing />} />
              <Route path="/billing/success" element={<BillingSuccess />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </CurrencyProvider>
        </WalletProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
